<template>
  <div>
    <div class="d-flex flex-column" dir="rtl" v-if="content?.form?.iframe_url">
      <div class="d-flex flex-row">
        <div class="f20-l30-b pointer" @click="$emit('close')">X</div>
        <div class="f20-l30-b flex-grow-1 text-center" v-html="content.title"></div>
      </div>
      <div class="f14-l17 flex-grow-1" v-html="content.subtitle"></div>
      <div class="f14-l17 red" id="popup-error-message"></div>
      <div class="f14-l17 red" id="popup-error-message-description"></div>
      <LoadingIndicator dir="ltr" v-if="popupLoadingIndicator" />
      <iframe :src="content?.form?.iframe_url" :class="classSelector()" :allow="this.$isGOOGLE() ? 'payment' : null"></iframe>
    </div>

    <div class="d-flex flex-column" dir="rtl" v-else-if="content?.form">
      <div class="d-flex flex-row">
        <div class="f20-l30-b pointer" @click="$emit('close')">X</div>
        <div class="f20-l30-b text-center flex-grow-1" v-html="content.title"></div>
      </div>
      <div v-if="content.description" class="f14-l17 margin-tb-20 text-center">{{content.description}}</div>
      <form class="formfield-round-border formfield-16" dir="rtl" :action="content.form?.submit?.url || content.form?.submit?.href || content.form.button.href" ref="form" :method="content.form?.submit?.method || `POST`" @submit.prevent="false" @keyup.enter="onSubmit(null)">
        <FormFieldComponent :field="customizeField(field)" v-for="(field,idx) in content.form.fields" :key="field.data_name || 'field_' + idx" />
        <div v-if="content.form.new_address" class="red f14-l17 formfield-margin-wrapper padding-tb-10 pointer"
          @click="openpopup(content.form.new_address.popup.form)">{{content.form.new_address.popup.form.title}}</div>
        <div class="f14-l17 red text-center" v-if="errorMessage" v-html="errorMessage"></div>
       
        <ButtonComponent  v-if="!isSubmitting" :caption="content.form?.submit?.label || content.form.button.label" @click="onSubmit(null)" @keyup.enter="onSubmit(null)" class="margin-top-20" />
      </form>

    </div>

    <div class="d-flex flex-column" dir="rtl" v-else-if="content?.body">
      <div class="d-flex flex-row">
        <div class="f20-l30-b pointer" @click="$emit('close')">X</div>
        <div class="f20-l30-b flex-grow-1 text-center" v-html="content.header.title_html"></div>
      </div>
      <HorizontalSplitter class="margin-tb-20" />
      <div class="f14-l17 red-link" v-html="content.body.text_html"></div>
      <HorizontalSplitter class="margin-tb-20" />
      <div class="d-flex flex-row">
        <ButtonComponent class="flex-grow-1 margin-lr-5" v-for="btn in content.buttons" :key="btn.label" :caption="btn.label" @click="btnAction(btn)" @keyup.enter="btnAction(btn)" />
        <!-- <ButtonComponent :caption="btn.label" v-if="!btn.cancel"  /> -->
      </div>
    </div>

    <div class="d-flex flex-column" dir="rtl" v-else-if="content?.dish">
      <div class="d-flex flex-row">
        <div class="f20-l30-b pointer" @click="$emit('close')">X</div>
        <div class="f20-l30-b flex-grow-1 text-center" v-html="content.title"></div>
      </div>
      <HorizontalSplitter class="margin-tb-20" />

      <div class="d-flex flex-row">
        <ImgImage :img="$responsive(content.dish.image)" />
        <div class="d-flex flex-column padding-10 w-100">
          <div class="d-flex flex-row w-100">
            <div class="f15-l18-m flex-grow-1 ">{{content.dish.title}}</div>
            <div class="f15-l18-m text-nowrap">
              <PriceComponent :value="content.dish.price" />
            </div>
          </div>
          <div class="f14-l19 margin-top-5 c58">{{content.dish.description}}</div>
          <div class="f14-l19 c58" v-for="(option,idx) in content.dish.deal_options" :key="idx">{{option.text}}</div>
          <div class="f14-l19 bold">{{content.dish.amount.text}}</div>
          <div class="f14-l19 red">{{content.dish.cook.text}}</div>
        </div>

      </div>
      <form class="formfield-round-border formfield-16" :action="content.dish.dish_comment.field.update_url" ref="form" method="POST">
        <FormFieldComponent :field="content.dish.dish_comment.field" />
      </form>
      <HorizontalSplitter class="margin-tb-20" />
      <div class="d-flex flex-row">
        <ButtonComponent class="flex-grow-1 margin-lr-5" v-for="btn in content.buttons" :key="btn.text" :caption="btn.text" @click="btnAction(btn)" @keyup.enter="btnAction(btn)" :variant="btn.variant || 'red'" />
      </div>
    </div>

    <div class="d-flex flex-column" dir="rtl" v-else-if="content?.str">
      <div class="d-flex flex-row" v-html="content.str">
      </div>
    </div>

    <div class="d-flex flex-column" dir="rtl" v-else-if="contentIsString()">
      <div class="d-flex flex-row" v-html="content">
      </div>
    </div>
    <div  v-if="wizard && showWizard">
      <div class="f20-l30-b pointer" @click="$emit('close')">X</div> 
      <WizardPopupComponent 
        :showClose="true" 
        :wizard="wizard" 
        @close="$emit('close')" 
        :formMethod="formMethod" 
        @submit="onSubmit"
      />

    </div>

    <!-- Processing indicator -->
    <div v-if="showLoadingIndicator" class="loader-container margin-top-20">
      <LoadingIndicator dir="ltr" />
      <div class="processing-message text-center margin-top-10 f14-l19 bold"
        v-if="this.wizard?.processing_message"
        v-html="this.wizard.processing_message">
      </div>
    </div>


    <!-- Response message -->
    <div v-if="responseMessage" class="margin-top-20">
      <div class="f16-l17 text-center" v-if="responseMessage.title" v-html="responseMessage.title"></div>
      <div class="f14-l17 text-center margin-top-10" v-html="responseMessage.text"></div>
    </div>

    <!-- Error message -->
    <!-- <div v-if="errorMessage" class="error-message red text-center margin-top-20">
      {{ errorMessage }}
    </div> -->

    <!-- Response buttons -->
    <div v-if="responseButtons && responseButtons.length > 0" class="margin-top-20">
      <HorizontalSplitter class="margin-tb-20" />
      <div class="d-flex flex-row">
        <ButtonComponent 
          v-for="(btn, index) in responseButtons" 
          :key="index" 
          :caption="btn.label" 
          @click="btnAction(btn)" 
          @keyup.enter="btnAction(btn)" 
          class="flex-grow-1 margin-lr-5" 
        />
      </div>
    </div>

  </div>
</template>
<script>
import { chatService } from '@/services/chatService';
import {formSubmit, fetch2} from '@/modules/configuration.js';
import {openCart} from '@/modules/utils.js';
import ButtonComponent from "@/components/form/ButtonComponent"
import HorizontalSplitter from "@/components/generic/HorizontalSplitter.vue"
import ImgImage from "@/components/generic/ImgImage.vue"
import FormFieldComponent from "@/components/form/FormFieldComponent"
import LoadingIndicator from '@/components/LoadingIndicator.vue'
import PriceComponent from "@/components/generic/PriceComponent.vue";
import WizardPopupComponent from "@/components/search/WizardPopupComponent";

export default {
  components: {
    ButtonComponent,
    HorizontalSplitter,
    ImgImage,
    FormFieldComponent,
    LoadingIndicator,
    PriceComponent,
    WizardPopupComponent
  },
  props: {
    content: Object,
    url: Object,
    formMethod: {
      type: String,
      default: 'GET'
    },
    useWebSocket: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      popupLoadingIndicator: false,
      loading: false,
      wizard: null,
      errorMessage: null,
      isSubmitting: false,
      responseMessage: null,
      responseButtons: [],
      showWizard: true,
      showLoadingIndicator: false,
      wsEnabled: false,
      chatService: chatService,
      conversationId: null
    }
  },
  mounted() {
    const u = this.url?.url;
    if (u && u.indexOf('wizard') >= 0) {
      this.getData(this.url.url).then(() => {
        if (this.useWebSocket || this.shouldUseWebSocket()) {
          this.wsEnabled = true;
          const userSessionId = this.wizard?.user_session_id;
          // console.log('Initializing WebSocket with user_session_id:', userSessionId);
          if (userSessionId) {
            this.conversationId = userSessionId;
            this.initializeWebSocket(userSessionId);
          }
        }
      }).catch(error => {
        console.error('Error in mounted:', error);
      });
    }
  },
  beforeUnmount() {
    if (this.wsEnabled) {
      this.chatService.disconnect();
    }
  },
  methods: {
    shouldUseWebSocket() {
      return this.url?.url?.includes('wizard') && this.formMethod === 'POST';
    },

    initializeWebSocket(userSessionId) {
      // console.log('Initializing WebSocket connection');
      try {
        this.chatService.connect();
        this.chatService.subscribe({
          onConnected: () => {
            // console.log('WebSocket connection established');
          },
          onDisconnected: () => {
            // console.log('WebSocket connection closed');
            this.wsEnabled = false;
          },
          onChatStarted: (data) => {
            // console.log('Chat started:', data);
            this.showLoadingIndicator = true;
            this.conversationId = data.conversation_id;
          },
          onChatCompleted: (data) => {
            // console.log('Chat completed:', data);
            this.handleChatResponse(data);
          },
          onError: (error) => {
            // console.error('WebSocket error:', error);
            this.handleError(error);
          },
          onReceived: (data) => {
            // console.log('Received message:', data);
            this.handleChatResponse(data);
          }
        }, userSessionId);
      } catch (error) {
        // console.error('Failed to initialize WebSocket:', error);
        this.wsEnabled = false;
        this.handleError(error);
      }
    },

    handleChatResponse(response) {
      // console.log('PopupRenderer: Handling chat response:', response);
      
      if (!response) {
        // console.error('PopupRenderer: Received empty response');
        return;
      }

      if (response.event === 'chat_started') {
        // console.log('PopupRenderer: Chat started event received');
        this.showLoadingIndicator = true;
        return;
      }

      if (response.status === 'completed' && response.response) {
        // console.log('PopupRenderer: Completed response received:', response.response);
        this.showLoadingIndicator = false;
        this.showWizard = false;
        this.responseMessage = {
          title: response.response.title,
          text: response.response.text
        };
        
        if (response.response.content?.buttons) {
          this.responseButtons = response.response.content.buttons;
        }

        if (!response.response.keep_open) {
          
          this.$emit('close', true, response, this.content?.requestId);
        }
        return;
      }

      if (response.status === 'error') {
        // console.error('PopupRenderer: Error response received:', response.error);
        this.handleError(response.error);
        return;
      }
    },

    handleError(error) {
      // console.error('PopupRenderer: Handling error:', error);
      this.errorMessage = typeof error === 'string' ? error : error.message;
      this.showLoadingIndicator = false;
      this.isSubmitting = false;
    },

    async getData(url) {
      try {
        this.loading = true;
        const data = await fetch2(this, url);
        if (Object.keys(data).length === 0) return null;

        this.wizard = data;
        this.loading = false;
        return data;
      } catch (error) {
        // console.error('Error fetching data:', error);
        this.loading = false;
        return null;
      }
    },

    async onSubmit(formData) {
      this.isSubmitting = true;
      this.errorMessage = null;
      this.responseMessage = null;
      this.responseButtons = [];
      
      let form = formData || this.$refs.form;
      
      if (this.wsEnabled) {
        try {
          // Ensure we have a proper form element
          if (!(form instanceof HTMLFormElement) && !(form instanceof FormData)) {
            console.error('Invalid form input:', form);
            throw new Error('Invalid form input');
          }

          // Create FormData from the form element if it's not already FormData
          const actualFormData = form instanceof FormData ? form : new FormData(form);
          
          // Initialize the conversation object
          const formDataObj = {
            conversation: {}
          };

          // First, collect all values for each field
          const fieldValues = {};
          actualFormData.forEach((value, key) => {
            if (!fieldValues[key]) {
              fieldValues[key] = [];
            }
            fieldValues[key].push(value);
          });

          // Then process all collected values
          Object.entries(fieldValues).forEach(([key, values]) => {
            // Match the field name from conversation[field_name] pattern
            const matches = key.match(/^conversation\[([^\]]+)\](\[\])?$/);
            
            if (matches) {
              const [, fieldName, isArray] = matches;
              
              if (isArray) {
                // For array fields, use all collected values
                formDataObj.conversation[fieldName] = values;
              } else {
                // For non-array fields, use the last value
                formDataObj.conversation[fieldName] = values[values.length - 1];
              }
            }
          });

          // Get user session ID
          const userSessionId = formDataObj.conversation.user_session_id;
          
          if (!userSessionId) {
            await this.submitViaHttp(form);
            return;
          }

          this.showWizard = false;
          this.showLoadingIndicator = true;
          await this.chatService.processChat(userSessionId, formDataObj);
          
        } catch (error) {
          console.error('PopupRenderer: WebSocket submission failed:', error);
          this.handleError(error);
          
          if (!error.message.includes('WebSocket') && !error.message.includes('timeout')) {
            await this.submitViaHttp(form);
          }
        } finally {
          this.isSubmitting = false;
        }
      } else {
        await this.submitViaHttp(form);
      }
    },

    async btnAction(btn) {
      if (!btn) return;
      try {
        if (btn.cancel) {
          this.$emit('close');
          return;
        }

        if (btn.method === 'POST') {
          let postData = {};
          if (btn.post_params) {
            btn.post_params.forEach(param => {
              postData[param.name] = param.val;
            });
          }

          const response = await formSubmit(this, null, btn.href, postData);
          this.$emit('orderUpdated', response);
        } 
        else {
          let link = btn.url || btn.href;
          if (link) {
            if (link.indexOf("add_to_cart") > 0) {
              let response = await formSubmit(this, null, link);
              if (response.popup_content || response?.prompt_json?.popup_content) {
                openCart(this,response);
                // if (this.$isDesktop(true) && response?.cart?.url) {
                //   this.$store.dispatch('showPopupWithUrl', response.cart.url);
                // } else if (response.popup_content || response?.prompt_json?.popup_content) {
                //   this.$store.dispatch('showPopup', response.popup_content || response?.prompt_json?.popup_content);
                // }
              }
            } else {
              if (this.$route.fullPath == link) {
                this.$router.go(0);
              } else if (link.indexOf("/") == 0) {
                const path = link.split('?')[0];
                if (this.$route.path == path){
                  window.location.href = link;
                } else {
                  this.$router.push(link);
                }
              }
            }
          }
        }
        this.$emit('close');
     } catch (error) {
        this.handleError(error);
      }
    },

    contentIsString() {
      return this?.content instanceof String;
    },

    openpopup(json) {
      this.$emit('close');
      this.$store.dispatch('showPopup', {form: json, requestId: this.content?.requestId});
    },

    customizeField(field) {
      field["desktopClass"] = "col-12";
      return field;
    },

    classSelector() {
      return this.content.form.style + '_iframe';
      // return {
      //   'iframe-height': true,
      //   'iframe-height-desktop': this.$isDesktop()
      // }
    },

    async submitViaHttp(form) {
      // console.log('PopupRenderer: submitViaHttp');
      try {
        this.isSubmitting = true; // Set isSubmitting to true
        // let form = this.$refs.form;
        const response = await formSubmit(this, form, null, null);
        // eslint-disable-next-line
        if (response.hasOwnProperty("success") && response.success === false && response.error) {
          this.errorMessage = response.error;
          this.isSubmitting = false; // Reset isSubmitting to false
          return;
        }
        // eslint-disable-next-line
        else if (response.hasOwnProperty("success") && response.success === true && response.message) {
          this.responseMessage = response.message;
          if (response.content && response.content.buttons) {
            this.responseButtons = response.content.buttons; // Set responseButtons based on response content
          }
          this.isSubmitting = false; // Reset isSubmitting to false
          if (response.keep_open) {
            return;
          }
        }
        this.$emit('close', response.success, response, this.content?.requestId);
        this.isSubmitting = false; // Reset isSubmitting to false
      } catch (error) {
        this.handleError(error);
      }
    }
  },
  watch: {
    async $route(to/*, from*/) {
      if (to.hash === "#loading") {
        this.popupLoadingIndicator = true;
      }
      if (to.hash === "#loaded") {
        this.popupLoadingIndicator = false;
      }
    }
  }
}
</script>
<style scoped>
.processing-message {
  text-align: center;
  margin-top: 1rem;
  color: #666;
}

.loader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}
.formfield-no-margin .formfield-margin-wrapper {
  margin: 0;
}

.card_iframe {
  width: 300px; 
  height: 450px; 
  margin: auto;
}
.credit_iframe {
  width: 300px; 
  height: 450px; 
  margin: auto;
}

.bit_iframe {
  z-index: 100;
  width: 100%;
  height: 100%;
  position: fixed;
  border: 0;
  top: 0;
  right: 0;
  background-color: transparent !important;
}
.apple_iframe {
  width: 300px; 
  height: 300px; 
  margin: auto;
}

.google_iframe {
  width: 300px; 
  height: 300px; 
  margin: auto;
}

.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px; /* Adjust height as needed */
  min-height: 300px;
}

.button-group {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>